import { Control, UseFormSetValue } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { BrowserSettingsSection } from "./BrowserSettingsSection";
import { SectionWrapper } from "./SectionWrapper";

interface BrowserSectionProps {
  faviconPreview: string | null;
  onFaviconUpload: (file: File) => void;
  onFaviconRemove: () => void;
  faviconUrl: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setValue: UseFormSetValue<any>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>;
}

export const BrowserSection = ({
  faviconPreview,
  onFaviconUpload,
  onFaviconRemove,
  faviconUrl,
  setValue,
  control,
}: BrowserSectionProps) => {
  const { t } = useTranslation();
  return (
    <SectionWrapper
      instruction={t("preferences.uiBranding.instructions.browser")}
    >
      <BrowserSettingsSection
        faviconPreview={faviconPreview}
        onFaviconUpload={onFaviconUpload}
        onFaviconRemove={onFaviconRemove}
        control={control}
        faviconUrl={faviconUrl}
        onFaviconUrlClear={() =>
          setValue("faviconUrl", "", { shouldDirty: true })
        }
      />
    </SectionWrapper>
  );
};
